import axios from "axios";
import Cookies from "js-cookie";
export const MAX_FILE_SIZE = 12 * 1024 * 1024; // 12 MB in bytes

export const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
export const AuthClientId = process.env.REACT_APP_MS_CLIENT_ID
export const Auth_CompStaffing_Tenant = process.env.REACT_APP_MS_COMPSTAFIFNG_TENANT
export const Auth_Ms_redirectUri = process.env.REACT_APP_MS_REDIRECT_URL
export const TINYEMCE_API_KEY = process.env.REACT_APP_TINYEMCE_API_KEY
export const systemState = process.env.REACT_APP_SYSTEM_STATE
export const siteTitle = 'KPI Tool'


const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

api.interceptors.request.use(
    (config) => {
        const accessToken = Cookies.get('accessToken');
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        console.log('API Request:', {
            method: config.method,
            url: config.url,
            params: config.params,
            data: config.data,
            headers: config.headers
        });
        return config;
    },
    (error) => {
        console.error('API Request Error:', error);
        return Promise.reject(error);
    }
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};

api.interceptors.response.use(
    (response) => {
        console.log('API Response:', {
            status: response.status,
            url: response.config.url,
            data: response.data
        });
        return response;
    },
    async (error) => {
        console.error('API Error:', {
            message: error.message,
            status: error.response?.status,
            data: error.response?.data,
            url: error.config?.url
        });

        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then(token => {
                    originalRequest.headers.Authorization = `Bearer ${token}`;
                    return api(originalRequest);
                }).catch(err => {
                    return Promise.reject(err);
                });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            const refreshTokenValue = Cookies.get('refreshToken');
            if (!refreshTokenValue) {
                Cookies.remove('accessToken');
                Cookies.remove('refreshToken');
                localStorage.clear();
                window.location.href = process.env.REACT_APP_DOMAIN_NAME || '/login';
                return Promise.reject(error);
            }

            try {
                const response = await axios.post(`${API_URL}/auth/token/refresh/`, {
                    refresh: refreshTokenValue
                });

                const { access } = response.data;
                Cookies.set('accessToken', access);
                localStorage.setItem('access', access);

                originalRequest.headers.Authorization = `Bearer ${access}`;

                processQueue(null, access);

                return api(originalRequest);
            } catch (refreshError) {
                processQueue(refreshError, null);
                Cookies.remove('accessToken');
                Cookies.remove('refreshToken');
                localStorage.clear();
                window.location.href = process.env.REACT_APP_DOMAIN_NAME || '/login';
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    }
);

export default api;
